import { BoxParams } from "../components/Box";

const allJson = require('../data/all_words.json');
const selectedJson = require('../data/selectedl_words.json');

const words = selectedJson.words;
const allWords = allJson.words;

const LAUNCH_DAY = '2022-01-29'
const LAUNCH_DATE = new Date(LAUNCH_DAY);

const TODAY = new Date().toISOString().split('T')[0];
const TODAY_DATE = new Date(TODAY);

const DiffMs = TODAY_DATE.getTime() - LAUNCH_DATE.getTime()
const DiffDays = DiffMs / 1000 / 60 / 60 / 24
const DAY_NUMBER = DiffDays;

export const getWords = ():string[] => {
  return words;
}

export const isAWord = (word:string):boolean => {
  word = word.toLowerCase();
  return allWords.indexOf(word) > -1;
}

export const getWordNumber = ():number => {
  const wordNumber = DAY_NUMBER % words.length;
  return wordNumber;
}

export const getTodaysWord = ():string[] => {
  const wordNumber = getWordNumber();
  return words[wordNumber].toUpperCase().split('')
}

export const calculateResults = (guessWord:string, correctWord:string):BoxParams[] => {
  const guessLetters = guessWord.split('');
  const correctLetters = correctWord.split('');

  const exactMatches = guessLetters
    .map((letter, index) => letter === correctLetters[index] ? letter : undefined);

  const matchesWithWrongPos = guessLetters
    .map((letter, index) => letter !== correctLetters[index] &&
    correctLetters.indexOf(letter) > -1  ? letter : undefined);

  const availableYellowSpots: { [key: string]: number; } = {};
  correctLetters.forEach((letter, index) => {
    if(!availableYellowSpots[letter]) {
      availableYellowSpots[letter] = 0
    }

    if(!exactMatches[index]) {
      availableYellowSpots[letter] += 1
    }
  })

  const answers = guessLetters.map((letter, index) => {
    let answer:string = '';

    if(exactMatches[index]) {
      answer = 'PERFECT'
    } else if(matchesWithWrongPos[index] && availableYellowSpots[letter] > 0) {
      answer = 'WRONG_POS'
      availableYellowSpots[letter] -= 1
    } else {
      answer = 'NO'
    }

    return { letter, answer };
  });

  return answers;
}
